export default [
  {
    path: '/document/help',
    component: () => import('@/views/document/index.vue'),
    meta: {
      docType: 'help'
    }
  },
  {
    path: '/document/help/doc',
    component: () => import('@/views/document/help'),
  },
  {
    path: '/document/api',
    component: () => import('@/views/document/index.vue'),
    meta: {
      docType: 'api'
    }
  },
  {
    path: '/document/api/doc',
    component: () => import('@/views/document/api'),
  }
]